import { UserDetailsResponseDtoAppFeaturesItem } from '@/generated/nabisNYWebAPI.schemas';

export const getHasAllAppFeatures =
  (appFeatures: UserDetailsResponseDtoAppFeaturesItem[]) => (features: UserDetailsResponseDtoAppFeaturesItem[]) =>
    features.every((f) => appFeatures.includes(f));
